export default __webpack_public_path__ + "static/media/save_to_homescreen_apple.763ece4d.png";